const isRTL = (element) => {
    if (typeof document !== 'undefined' && document.documentElement.dir === 'rtl') {
        return true;
    }
    if (element) {
        return element.closest('[dir="rtl"]') !== null;
    }
    return false;
};

export { isRTL as default };
//# sourceMappingURL=isRTL.js.map
